module.exports = __webpack_public_path__ + "static/media/44_B.f6e87c4f.png";